import styled from "styled-components";
import { size, palette } from "styled-theme";

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0px;
  cursor: pointer;

  .tab-group {
    display: flex;
    margin: 25px 0 0;
    padding: 0 0 20px;
    width: 100%;
    color: ${palette("grayscale", 1)};
    font-size: 18px;
    font-weight: bold;
  }

  .ball-number {
        background-color: ${palette("grayscale", 1)};
    }

  .active {
    color: ${palette("color", 15)};
    border-bottom: 4px solid ${palette("color", 15)};

    .ball-number {
        background-color: ${palette("color", 15)};
    }
  }

  @media only screen and (min-width: ${size("M")}) {
    gap: 10px;
  }
`;

export default Wrapper;
